/**
 * WordPress Dependencies
 */
import {
	store,
	getElement,
	getContext,
	getServerState,
	getServerContext,
} from '@wordpress/interactivity';

const { state, actions } = store('prc-rls/context-provider', {
	state: {
		get getSelected() {
			return state.selected;
		},
	},
	actions: {
		*goToPath(newUrl) {
			actions.prefetch(newUrl);
			setTimeout(() => {
				window.location.href = newUrl;
			}, 500);
		},
		/**
		 * Check if the newUrl is already in the prefetched array, if not add
		 * it and then prefetch the newUrl.
		 * @param {string} newUrl
		 * @return
		 */
		*prefetch(newUrl) {
			if (state.prefetchedUrls.includes(newUrl)) {
				return;
			}
			state.isProcessing = true;
			state.prefetchedUrls.push(newUrl);
			const router = yield import('@wordpress/interactivity-router');
			yield router.actions.prefetch(newUrl);
			state.isProcessing = false;
		},
	},
	callbacks: {
		onInit() {
			const width = document.documentElement.clientWidth;
			if (width <= 600) {
				state.isMobile = true;
			} else {
				state.isMobile = false;
			}
		},
		onResize: () => {
			const width = document.documentElement.clientWidth;
			if (width <= 600) {
				state.isMobile = true;
			} else {
				state.isMobile = false;
			}
		},
		runEmbargoCheck: () => {
			const { runEmbargoCheck } = state;
			if (runEmbargoCheck) {
				console.log('Processing runEmbargoCheck::', runEmbargoCheck);
				// get the current url and add &embargo_nonce=state.embargoNonce to it
				const newUrl = window.wp.url.addQueryArgs(
					window.location.href,
					{
						embargo_nonce: state.embargoNonce,
					}
				);

				fetch(newUrl, {
					method: 'GET',
				}).then((d) => {
					console.log('Embargo check complete', d);
					// // redirect to the new url without the embargo_nonce and without the ?rls-embargo query
					// window.location.href = window.wp.url.removeQueryArgs(
					// 	window.location.href,
					// 	['embargo_nonce', 'rls-embargo']
					// );
				});
			}
		},
	},
});
